import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';

const ReadyToPaySkeleton: React.FC = () => (
  <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    minHeight: '100dvh',
    width: '100%',
    bgcolor: 'background.default',
    boxSizing: 'border-box',
    paddingTop: 'env(safe-area-inset-top, 0px)',
  }}>
    {/* Header Skeleton */}
    <Box sx={{
      py: 1, px: 2,
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid #e0e0e0',
      bgcolor: '#ffffff',
      width: '100%',
      boxSizing: 'border-box',
      flexShrink: 0,
      position: 'sticky',
      top: 0,
      zIndex: 10
    }}>        
      <Typography component="div" sx={{ flexGrow: 1, textAlign: 'center', color: '#333', ml: '-40px', fontSize: '1.5rem', fontWeight: 600 }}>
        Tu Orden
      </Typography>
    </Box>

    {/* Content Area Skeleton */}
    <Box sx={{
      flexGrow: 1,
      overflowY: 'auto',
      width: '100%',
      maxWidth: '600px',
      mx: 'auto',
      bgcolor: '#ffffff',
      boxSizing: 'border-box',
      paddingBottom: '130px',
      p: 2
    }}>        
      {/* User Accordion Skeletons */}
      {[1, 2].map((userIndex) => (
        <Box key={userIndex} sx={{ mb: 2, border: '1px solid #f0f0f0', borderRadius: 2, overflow: 'hidden' }}>
          {/* Accordion Header Skeleton */}
          <Box sx={{ bgcolor: '#f8f9fa', px: 2, py: 1.5, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Skeleton variant="rounded" width={20} height={20} />
            <Skeleton variant="text" width="40%" height={24} />
            <Box sx={{ flexGrow: 1 }} />
            <Skeleton variant="text" width="20%" height={20} />
            <Skeleton variant="circular" width={24} height={24} />
          </Box>
          
          {/* Order Items Skeleton */}
          <Box sx={{ p: 2 }}>
            {[1, 2, 3].map((itemIndex) => (
              <Box key={itemIndex} sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, pb: 2, borderBottom: itemIndex < 3 ? '1px solid #f0f0f0' : 'none' }}>
                <Skeleton variant="rounded" width={20} height={20} />
                <Skeleton variant="rectangular" width={60} height={60} sx={{ borderRadius: 1 }} />
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="80%" height={20} sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width="60%" height={16} sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width="40%" height={16} />
                </Box>
                <Box sx={{ textAlign: 'right' }}>
                  <Skeleton variant="text" width={40} height={16} sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width={60} height={20} />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>

    {/* Bottom Payment Section Skeleton */}
    <Box sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      bgcolor: '#ffffff',
      borderTop: '1px solid #e0e0e0',
      p: 2,
      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)'
    }}>
      <Box sx={{ maxWidth: '600px', mx: 'auto' }}>
        {/* Total Section */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Skeleton variant="text" width="30%" height={24} />
          <Skeleton variant="text" width="20%" height={28} />
        </Box>
        
        {/* Payment Button */}
        <Skeleton variant="rounded" width="100%" height={48} sx={{ borderRadius: 2 }} />
      </Box>
    </Box>
  </Box>
);

export default ReadyToPaySkeleton; 